import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("living_sleeping/index"),
  
  store: (userData) => clientAuth.post('living_sleeping/store', { json: userData }),
  

  show:(id)=>clientAuth.get('living_sleeping/show/'+id),

  update:(id,userData)=>clientAuth.post('living_sleeping/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`living_sleeping/destroy/${id}`),
};